module.exports = __webpack_public_path__ + "img/avatar.aee7ad2b.png";